import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import {
  CircularProgress,
  IconButton,
  MenuItem,
  Modal,
  Select,
  Typography,
} from '@material-ui/core';
import ActionButton from '../../../components/ActionButton';
import { InfoOutlined } from '@material-ui/icons';
import { getEsercizioCommerciale } from '../../../utils/api/esercizi_commerciali_api';
import CustomTooltip from '../../../components/CustomTooltip';
import PropTypes from 'prop-types';
import { reportApiError } from '../../../utils/reportApiError';

const styles = (theme) => ({
  modal: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  progress: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '200px',
  },
  modalContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: theme.spacing(3),
    textAlign: 'center',
    backgroundColor: 'white',
    color: 'black',
    padding: theme.spacing(4),
    borderRadius: '6px',
    boxShadow: theme.shadows[6],
    overflowY: 'auto',
    width: '90%',
    maxWidth: '720px',
  },
  dialogTitle: {
    textAlign: 'center',
  },
  sectionHeading: {
    textAlign: 'center',
    color: theme.palette.text.secondary,
  },
  warning: {
    textAlign: 'center',
    maxWidth: 480,
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  modalitaWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.spacing(1),
    width: '100%',
  },
  selectWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.spacing(1),
    width: '75%',
  },
});

class ModalSelezioneModalita extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tipologiaItem: true,
      modalitaControllo: this.props.isControlliSelectionBlocked,
      gestioneOperativaSeparata: false,
      loading: true,
    };
  }

  componentDidMount() {
    getEsercizioCommerciale(this.props.selectedEsercizio)
      .then((esercizio) => {
        this.setState({
          gestioneOperativaSeparata:
            esercizio.esercizio.gestioneOperativaSeparata,
          loading: false,
        });
      })
      .catch((error) => {
        reportApiError(error);
      });
  }

  render() {
    const { classes } = this.props;

    return (
      <Modal
        open={this.props.open}
        onClose={this.props.onClose}
        className={classes.modal}
      >
        {this.state.loading ? (
          <div className={classes.progress}>
            <CircularProgress />
          </div>
        ) : (
          <div className={classes.modalContainer}>
            <Typography variant="h6" className={classes.dialogTitle}>
              Opzioni manuale
            </Typography>
            {this.props.filtroGestioneSeparata === false &&
              this.state.gestioneOperativaSeparata && (
                <Typography
                  variant="body2"
                  color="error"
                  className={classes.warning}
                >
                  N.B. In questo caso il manuale verrà creato con la sola parte
                  descrittiva.
                </Typography>
              )}
            {!this.state.gestioneOperativaSeparata && (
              <div className={classes.modalitaWrapper}>
                <Typography
                  variant="subtitle1"
                  className={classes.sectionHeading}
                >
                  Modalità di gestione dei controlli di non conformità
                </Typography>
                <div className={classes.selectWrapper}>
                  <CustomTooltip
                    arrow
                    placement="right"
                    title={
                      <Typography variant="caption">
                        Il manuale selezionato è generato da un altro manuale
                        con controlli in modalità <i>semplificata</i> e dunque
                        non è possibile cambiarlo in uno con controlli in
                        modalità <i>normale</i>
                      </Typography>
                    }
                    disableHoverListener={
                      !this.props.isControlliSelectionBlocked
                    }
                  >
                    <Select
                      variant="outlined"
                      fullWidth
                      value={this.state.modalitaControllo}
                      onChange={(e) => {
                        this.setState({
                          modalitaControllo: e.target.value,
                        });
                      }}
                      disabled={this.props.isControlliSelectionBlocked}
                    >
                      <MenuItem value={false}>Normale</MenuItem>
                      <MenuItem value={true}>Semplificata</MenuItem>
                    </Select>
                  </CustomTooltip>
                  <CustomTooltip
                    arrow
                    placement="right"
                    title={
                      <Typography variant="caption">
                        <b>Modalità normale: </b> i controlli saranno dotati di
                        limiti, cause e azioni correttive.
                        <br></br>
                        <b>Modalità semplificata: </b> i controlli avranno solo
                        le azioni correttive.
                      </Typography>
                    }
                  >
                    <IconButton color="secondary" size="small">
                      <InfoOutlined fontSize="small" />
                    </IconButton>
                  </CustomTooltip>
                </div>
              </div>
            )}
            <div className={classes.modalitaWrapper}>
              <Typography
                variant="subtitle1"
                className={classes.sectionHeading}
              >
                Modalità di formattazione del manuale
              </Typography>
              <div className={classes.selectWrapper}>
                <CustomTooltip
                  arrow
                  placement="right"
                  title={
                    <Typography variant="caption">
                      Essendo il modello selezionato compilato dotato di
                      capitoli, l'elemento che si sta creando deve esserne
                      dotato a sua volta.
                    </Typography>
                  }
                  disableHoverListener={!this.props.isChapterSelectionBlocked}
                >
                  <Select
                    value={this.state.tipologiaItem}
                    fullWidth
                    variant="outlined"
                    size="small"
                    onChange={(e) => {
                      this.setState({
                        tipologiaItem: e.target.value,
                      });
                    }}
                    disabled={this.props.isChapterSelectionBlocked}
                  >
                    <MenuItem value={true}>Con capitoli</MenuItem>
                    <MenuItem value={false}>Senza capitoli</MenuItem>
                  </Select>
                </CustomTooltip>
                <CustomTooltip
                  arrow
                  placement="right"
                  title={
                    <Typography variant="caption">
                      <b>Modalità con capitoli: </b> Il manuale sarà dotato,
                      oltre ai paragrafi, di capitoli in cui racchiudere questi
                      ultimi.
                      <br></br>
                      <b>Modalità senza capitoli: </b> Il manuale sarà dotato
                      dei soli paragrafi.
                    </Typography>
                  }
                >
                  <IconButton color="secondary" size="small">
                    <InfoOutlined fontSize="small" />
                  </IconButton>
                </CustomTooltip>
              </div>
            </div>
            <div>
              <ActionButton
                label="Annulla"
                onClick={() => this.props.onClose()}
                disabled={false}
                grayVersion={false}
                showAlert={false}
                secondaryButton
              />
              <ActionButton
                label="Prosegui"
                onClick={() => {
                  const tipologiaRevisione = this.state
                    .gestioneOperativaSeparata
                    ? 'DESCRITTIVA'
                    : 'COMBINATA';

                  this.props.onProseguiButton(
                    this.state.tipologiaItem,
                    this.props.selectedEsercizio,
                    this.state.modalitaControllo,
                    tipologiaRevisione,
                  );
                }}
              />
            </div>
          </div>
        )}
      </Modal>
    );
  }
}

ModalSelezioneModalita.propTypes = {
  classes: PropTypes.object.isRequired,
  filtroGestioneSeparata: PropTypes.oneOf([true, false, null]),
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onProseguiButton: PropTypes.func.isRequired,
  selectedEsercizio: PropTypes.number.isRequired,
  isControlliSelectionBlocked: PropTypes.bool.isRequired,
  isChapterSelectionBlocked: PropTypes.bool.isRequired,
};

export default withStyles(styles)(ModalSelezioneModalita);
